module.exports = __webpack_public_path__ + "img/naloxoneIcon.5c2e8cd6.png";